import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SingaporeFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15865'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15865)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H20V0H0V7.46667Z'
					fill='#E12237'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76144 6.53335C5.43652 6.53335 6.05692 6.3039 6.54586 5.92025C6.28685 6.01493 6.0065 6.06668 5.71382 6.06668C4.39886 6.06668 3.33287 5.02201 3.33287 3.73335C3.33287 2.44468 4.39886 1.40002 5.71382 1.40002C6.0065 1.40002 6.28685 1.45177 6.54586 1.54645C6.05691 1.16279 5.43652 0.93335 4.76144 0.93335C3.18348 0.93335 1.9043 2.18695 1.9043 3.73335C1.9043 5.27975 3.18348 6.53335 4.76144 6.53335ZM5.71382 3.26668C5.71382 3.52442 5.50062 3.73335 5.23763 3.73335C4.97464 3.73335 4.76144 3.52442 4.76144 3.26668C4.76144 3.00895 4.97464 2.80002 5.23763 2.80002C5.50062 2.80002 5.71382 3.00895 5.71382 3.26668ZM6.19001 5.60002C6.453 5.60002 6.6662 5.39108 6.6662 5.13335C6.6662 4.87562 6.453 4.66668 6.19001 4.66668C5.92702 4.66668 5.71382 4.87562 5.71382 5.13335C5.71382 5.39108 5.92702 5.60002 6.19001 5.60002ZM8.57096 5.13335C8.57096 5.39108 8.35777 5.60002 8.09477 5.60002C7.83178 5.60002 7.61858 5.39108 7.61858 5.13335C7.61858 4.87562 7.83178 4.66668 8.09477 4.66668C8.35777 4.66668 8.57096 4.87562 8.57096 5.13335ZM9.04715 3.73335C9.31015 3.73335 9.52334 3.52442 9.52334 3.26668C9.52334 3.00895 9.31015 2.80002 9.04715 2.80002C8.78416 2.80002 8.57096 3.00895 8.57096 3.26668C8.57096 3.52442 8.78416 3.73335 9.04715 3.73335ZM7.61858 1.86668C7.61858 2.12442 7.40539 2.33335 7.14239 2.33335C6.8794 2.33335 6.6662 2.12442 6.6662 1.86668C6.6662 1.60895 6.8794 1.40002 7.14239 1.40002C7.40539 1.40002 7.61858 1.60895 7.61858 1.86668Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default SingaporeFlagIcon;
